import * as colors from "@mui/material/colors";
import type { ColorType } from "src/theme/base.colors.light.ts";

// OKLCH Color Picker:
// https://oklch.com/#0.3032,0.0455,253.41,100

const themeDarkColors = {
  ...colors,
  common: {
    black: "#000",
    white: "#FFF",
  },
  blue: {
    100: "oklch(0.9 0.1 250)",
    400: "oklch(0.8 0.2 250)",
    500: "oklch(0.7 0.2 250)",
    600: "oklch(0.6 0.2 250)",
    700: "oklch(0.35 0.08 253)",
    800: "oklch(0.2747 0.0341 253)",
    900: "oklch(0.2155 0.0148 253)",
  },
  blueAccent: {
    100: "#e1e2fe",
    200: "#c3c6fd",
    300: "#a4a9fc",
    400: "#868dfb",
    500: "#6870fa",
    600: "#535ac8",
    700: "#3e4396",
    800: "#2a2d64",
    900: "#151632",
  },
  defy: {
    100: "oklch(0.97 0.02 175)",
    200: "oklch(0.9 0.04 175)",
    300: "oklch(0.84 0.0933 196)",
    400: "oklch(0.8 0.13 184)",
    500: "oklch(0.684 0.11 197)",
    700: "oklch(0.53 0.09 195)",
    800: "oklch(0.35 0.06 195)",
    900: "oklch(0.2 0.05 195)",
  },
  green: {
    100: "oklch(0.90 0.04  160)",
    200: "oklch(0.82 0.08  160)",
    300: "oklch(0.72 0.11  160)",
    400: "oklch(0.62 0.13  160)",
    500: "oklch(0.55 0.13  160)",
    600: "oklch(0.45 0.12  160)",
    700: "oklch(0.36 0.10  160)",
    800: "oklch(0.28 0.08  160)",
    900: "oklch(0.20 0.05  160)",
  },
  grey: {
    100: "#fcfcfc",
    200: "#F6F6F6",
    300: "#e0e0e0",
    400: "#c2c2c2",
    500: "#a3a3a3",
    600: "#858585",
    700: "#666666",
    800: "#525252",
    900: "#3d3d3d",
    950: "#292929",
    999: "#141414",
  },
  orange: {
    100: "oklch(0.92 0.06 65)",
    300: "oklch(0.78 0.14 65)",
    400: "oklch(0.72 0.16 65)",
    500: "oklch(0.65 0.18 65)",
    600: "oklch(0.55 0.15 65)",
    800: "oklch(0.35 0.10 65)",
    900: "oklch(0.26 0.07 65)",
    950: "oklch(0.16 0.04 65)",
  },
  pink: {
    ...colors.pink,
    400: "#AD1457",
    800: "#F8BBD0",
    900: "#FCE4EC",
  },
  primary: {
    100: "#d0d1d5",
    200: "#a1a4ab",
    300: "#727681",
    400: "#1F2A40",
    500: "#141b2d",
    600: "#101624",
    700: "#0c101b",
    800: "#080b12",
    900: "#040509",
  },
  red: {
    200: "oklch(0.82 0.10 25)",
    // 300: "oklch(0.72 0.15 25)",
    400: "oklch(0.65 0.18 25)",
    500: "oklch(0.58 0.20 25)",
    600: "oklch(0.50 0.18 25)",
    800: "oklch(0.32 0.12 25)",
    900: "oklch(0.22 0.08 25)",
  },
  yellow: {
    400: "oklch(0.8 0.16 95)",
  },
} satisfies ColorType;

export default themeDarkColors;
